import {AbstractList} from "./abstract-list";

export class TodayTaskList extends AbstractList {
  constructor(item: HTMLElement) {
    super(item);
  }
}
